import styled from "@emotion/styled"

export const UserManagementWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: auto auto 1fr;
	height: 100%;
	gap: 24px;
	.containerCardsSection {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 16px;
	}
`
